<div>
  <div class="modal-header py-2">
    <h5 class="d-flex align-items-center justify-content-between mb-0 w-100">
      <span>
        {{ todoData?.previous_month }} To Do
        <span *ngIf="todoData?.delay_days > 0" class="text-danger">(delayed by {{ todoData?.delay_days }}
          days)</span></span>
      <i (click)="modalDismiss($event)" class="ri-close-fill"></i>
    </h5>
  </div>
  <div class="modal-body py-2">
    <!-- <div class="card mb-2">
        <div class="card-body p-1">
          <i class="ri-git-pull-request-fill text-success"></i>
          <span
            >B2C to B2B conversion request :
            <span
              class="count"
              [ngClass]="{
                'text-underline': todoData?.b2c_to_b2b_conversion_request > 0,disabled: todoData?.b2c_to_b2b_conversion_request == 0
              }"
              >{{ todoData?.b2c_to_b2b_conversion_request }}</span
            ></span
          >
        </div>
      </div> -->

    <div class="card mb-2">
      <div class="card-body p-1">
        <i class="ri-calendar-2-line"></i>
        <span>Missing Dates to Upload Invoices :
          <span class="count" [ngClass]="{
              disabled: todoData?.missed_dates_to_upload_invoices == 0
            }">{{ todoData?.missed_dates_to_upload_invoices }}</span></span>
        <i *ngIf="todoData?.missed_dates_to_upload_invoices > 0" class="card-status red ri-error-warning-line"></i>
        <i *ngIf="todoData?.missed_dates_to_upload_invoices == 0" class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-body p-1">
        <img loading="lazy" src="../../../assets/images/health_pending.svg" alt="health_pending" />
        <span>B2B Pending :
          <span class="count" (click)="naviagteTo('b2b_pending')" [ngClass]="{
              'text-underline': todoData?.b2b_pending > 0,
              disabled: todoData?.b2b_pending == 0
            }">{{ todoData?.b2b_pending }}</span></span>
        <i *ngIf="todoData?.b2b_pending > 0" class="card-status red ri-error-warning-line"></i>
        <i [ngbTooltip]="
            'Due to Missed Dates to Upload Invoices Count ' +
            todoData?.missed_dates_to_upload_invoices
          " container="body" placement="left" *ngIf="
            todoData?.missed_dates_to_upload_invoices > 0 &&
            todoData?.b2b_pending == 0
          " class="card-status orange ri-information-2-line"></i>
        <i *ngIf="
            todoData?.missed_dates_to_upload_invoices == 0 &&
            todoData?.b2b_pending == 0
          " class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

     <div class="card mb-2">
      <div class="card-body p-1">
        <img loading="lazy" src="../../../assets/images/health_pending.svg" alt="health_pending" />
        <span>B2G Pending :
          <span class="count" (click)="naviagteTo('b2g_pending')" [ngClass]="{
              'text-underline': todoData?.b2b_pending > 0,
              disabled: todoData?.b2g_pending == 0
            }">{{ todoData?.b2g_pending }}</span></span>
        <i *ngIf="todoData?.b2g_pending > 0" class="card-status red ri-error-warning-line"></i>
        <i [ngbTooltip]="
            'Due to Missed Dates to Upload Invoices Count ' +
            todoData?.missed_dates_to_upload_invoices
          " container="body" placement="left" *ngIf="
            todoData?.missed_dates_to_upload_invoices > 0 &&
            todoData?.b2g_pending == 0
          " class="card-status orange ri-information-2-line"></i>
        <i *ngIf="
            todoData?.missed_dates_to_upload_invoices == 0 &&
            todoData?.b2g_pending == 0
          " class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-body p-1">
        <img loading="lazy" src="../../../assets/images/ri_plane-fill.svg" alt="ri_plane-fill" />
        <span>B2C TTX Pending:
          <span class="count" (click)="naviagteTo('b2c_ttx_pending')" [ngClass]="{
              'text-underline': todoData?.b2c_ttx_pending > 0,
              disabled: todoData?.b2c_ttx_pending == 0
            }">{{ todoData?.b2c_ttx_pending }}</span></span>

        <i *ngIf="todoData?.b2c_ttx_pending > 0" class="card-status red ri-error-warning-line"></i>
        <i [ngbTooltip]="
            'Due to Missed Dates to Upload Invoices Count ' +
            todoData?.missed_dates_to_upload_invoices
          " container="body" placement="left" *ngIf="
            todoData?.missed_dates_to_upload_invoices > 0 &&
            todoData?.b2c_ttx_pending == 0
          " class="card-status orange ri-information-2-line"></i>

        <i *ngIf="
            todoData?.missed_dates_to_upload_invoices == 0 &&
            todoData?.b2c_ttx_pending == 0
          " class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-body p-1">
        <i class="ri-error-warning-fill text-danger"></i>
        <span>Total Error :
          <span class="count" (click)="naviagteTo('total_error')" [ngClass]="{
              'text-underline': todoData?.total_error > 0,
              disabled: todoData?.total_error == 0
            }">{{ todoData?.total_error }}</span></span>

        <i *ngIf="todoData?.total_error > 0" class="card-status red ri-error-warning-line"></i>
        <i [ngbTooltip]="
            'Due to Missed Dates to Upload Invoices Count ' +
            todoData?.missed_dates_to_upload_invoices
          " container="body" placement="left" *ngIf="
            todoData?.missed_dates_to_upload_invoices > 0 &&
            todoData?.total_error == 0
          " class="card-status orange ri-information-2-line"></i>

        <i *ngIf="
            todoData?.missed_dates_to_upload_invoices == 0 &&
            todoData?.total_error == 0
          " class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>
    <!-- <div class="card mb-2">
        <div class="card-body p-1">
          <img
            loading="lazy"
            src="../../../assets/images/health_cancel.svg"
            alt="health_cancel"
          />
          <span
            >Rejected and Cancelled :
            <span
              class="count"
              [ngClass]="{ 'text-underline': todoData?.reject_and_cancelled > 0,disabled: todoData?.reject_and_cancelled == 0 }"
              >{{ todoData?.reject_and_cancelled }}</span
            ></span
          >
        </div>
      </div> -->
    <div class="card mb-2">
      <div class="card-body p-1">
        <i class="ri-close-circle-fill text-danger"></i>
        <span>Rejected but not Cancelled :
          <span class="count" (click)="naviagteTo('reject_but_not_cancelled')" [ngClass]="{
              'text-underline': todoData?.reject_but_not_cancelled > 0,
              disabled: todoData?.reject_but_not_cancelled == 0
            }">{{ todoData?.reject_but_not_cancelled }}</span></span>
        <i *ngIf="todoData?.reject_but_not_cancelled > 0" class="card-status red ri-error-warning-line"></i>
        <i *ngIf="todoData?.reject_but_not_cancelled == 0" class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-body p-1">
        <i class="ri-bill-line text-warning"></i>
        <span>E-Invoice request Pending :
          <span class="count" [ngClass]="{
              'text-underline': todoData?.e_invoice_request_pending > 0,
              disabled: todoData?.e_invoice_request_pending == 0
            }">{{ todoData?.e_invoice_request_pending }}</span></span>
        <i *ngIf="todoData?.e_invoice_request_pending > 0" class="card-status red ri-error-warning-line"></i>
        <i *ngIf="todoData?.e_invoice_request_pending == 0" class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

    <div class="card mb-2 card-1">
      <div class="card-body p-2 d-flex align-items-center justify-content-between gap-5">
        <div class="content">
          <p class="mb-0">
            Regular B2C consolidation for {{ todoData?.previous_month }}
          </p>
          <small>(Regular invoices from PMS)
            <!-- <span
              class="count"
              [ngClass]="{ 'text-underline': todoData?.regular_b2c_consolidation > 1,disabled: todoData?.regular_b2c_consolidation == 1 }"
              >View Consolidation</span
            > -->
          </small>
        </div>
        <span class="status" *ngIf="todoData?.regular_b2c_consolidation == 0">
          <i class="ri-circle-fill"></i> Pending
        </span>
        <span class="status text-success" *ngIf="todoData?.regular_b2c_consolidation >= 1">
          <i class="ri-circle-fill"></i> Success
        </span>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-body p-1">
        <i class="ri-map-pin-line text-warning"></i>
        <span>Missing TIN Location on Invoices :
          <span class="count" (click)="naviagteTo('missing_loc')" [ngClass]="{
              'text-underline': todoData?.missing_location_for_invoices > 0,
              disabled: todoData?.missing_location_for_invoices == 0
            }">{{ todoData?.missing_location_for_invoices }}</span></span>
        <i *ngIf="todoData?.missing_location_for_invoices > 0" class="card-status red ri-error-warning-line"></i>
        <i *ngIf="todoData?.missing_location_for_invoices == 0" class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-body p-1">
        <img loading="lazy" src="../../../assets/images/health_diamond.svg" alt="health_diamond" />
        <span>Un assigned TIN for AR Invoices :
          <span class="count" (click)="naviagteTo('no_tin_ar')" [ngClass]="{
              'text-underline': todoData?.no_tin_ar_invoices > 0,
              disabled: todoData?.no_tin_ar_invoices == 0
            }">{{ todoData?.no_tin_ar_invoices }}</span></span>
        <i *ngIf="todoData?.no_tin_ar_invoices > 0" class="card-status red ri-error-warning-line"></i>
        <i *ngIf="todoData?.no_tin_ar_invoices == 0" class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card-body p-1">
        <i class="ri-database-2-line text-warning"></i>
        <span>Invoices having value more than RM 10,000 in item :
          <span class="count" (click)="naviagteTo('has_high_value_transaction')" [ngClass]="{
              'text-underline': todoData?.has_high_value_transaction > 0,
              disabled: todoData?.has_high_value_transaction == 0
            }">{{ todoData?.has_high_value_transaction }}</span></span>
        <i *ngIf="todoData?.has_high_value_transaction > 0" class="card-status red ri-error-warning-line"></i>
        <i *ngIf="todoData?.has_high_value_transaction == 0" class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

    <div class="card mb-2">
      <div class="card-body p-1">
        <i class="ri-map-pin-2-line text-warning"></i>
        <span>TTX Invoices Missing Mandatory State or Country :
          <span class="count" (click)="naviagteTo('ttx_missing_state_or_country')" [ngClass]="{
              'text-underline': todoData?.ttx_missing_state_or_country > 0,
              disabled: todoData?.ttx_missing_state_or_country == 0
            }">{{ todoData?.ttx_missing_state_or_country }}</span></span>
        <i *ngIf="todoData?.ttx_missing_state_or_country > 0" class="card-status red ri-error-warning-line"></i>
        <i *ngIf="todoData?.ttx_missing_state_or_country == 0" class="card-status green ri-checkbox-circle-fill"></i>
      </div>
    </div>

    <!-- <div class="card mb-2">
        <div
          class="card-body p-1 d-flex align-items-center justify-content-between gap-5"
        >
          <div class="content">
            <p class="mb-0">Credit notes consolidation for January</p>
            <small>
              (Credit notes which are converted from B2B to B2C invoices)
              <span class="count">View Consolidation</span></small
            >
          </div>
          <span class="status"> <i class="ri-circle-fill"></i> Pending </span>
        </div>
      </div> -->
  </div>
</div>